import { cn } from '@/lib/utils.ts'
import type { ChartTooltipProps } from '@/types/chart'
import type { ReactNode } from 'react'
import type { TooltipProps } from 'recharts'

export function ChartTooltip<
  T extends object,
  ValueType extends number | string | Array<number | string> = string | number,
  NameType extends string = string,
>({ active, payload, renderHeader, headerClassName, items }: TooltipProps<ValueType, NameType> & ChartTooltipProps<T>) {
  if (!active || !payload?.length) return null

  const data = payload[0].payload as T

  return (
    <div className="rounded-sm bg-surface-backgroundElevated w-40 drop-shadow-md">
      <div
        className={cn(
          'font-EN-KR-caption-bold bg-surface-primary text-contents-accent pt-1 pb-1 flex align-middle justify-center rounded-t-sm',
          headerClassName,
        )}
      >
        {renderHeader(data)}
      </div>
      {items && items.length > 0 && (
        <div className="flex flex-col gap-1 p-2">
          {items.map((item) => (
            <div key={String(item.valueKey)} className="flex justify-between">
              <span className="font-EN-KR-caption-regular text-contents-secondary">
                {item.renderLabel ? item.renderLabel(item.label) : item.label}
              </span>
              <span className="font-EN-KR-caption-regular text-contents-secondary">
                {item.renderValue ? item.renderValue(data[item.valueKey]) : (data[item.valueKey] as ReactNode)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
